// extracted by mini-css-extract-plugin
export var falconContainer = "_ts-2";
export var offerCenter = "_ts-0";
export var roktContainer = "_ts-1";